export default {
	show (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'role/show', params, {withCredentials: true})
	}
}



// WEBPACK FOOTER //
// ./src/api/Role.js